export default class TiersModel {
    public enabled: boolean = false;
    public id: string = null;
    public label: string = null;
    public points: number = null;
}